import React from 'react'
import { Datagrid, TextField } from 'react-admin'
import DeleteAndExportBulk from 'ui-shared/BulkActionGroups/DeleteAndExportBulk'
import KFilters from 'ui-shared/KFilters'
import KPagination from 'ui-shared/KPagination'
import KList from 'ui-shared/KWrappers/KList'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import { BaseListProps } from 'ui-shared/WrappedInputs/CatalogItemBaseList'

const SupplierList: React.FC<BaseListProps> = (props) => {
  return (
    <SectionWrapper>
      <KList
        {...props}
        bulkActionButtons={<DeleteAndExportBulk />}
        exporter={false}
        pagination={<KPagination />}
        perPage={40}
        sort={{ field: 'name', order: 'ASC' }}
        filters={<KFilters />}
      >
        <Datagrid rowClick="edit">
          <TextField source="name" />
          <TextField
            source="category"
            label="form.fields.category"
            sortable={false}
          />
          <TextField source="email" sortable={false} />
          <TextField source="phone" sortable={false} />
        </Datagrid>
      </KList>
    </SectionWrapper>
  )
}

export default SupplierList
